import { Injectable, Optional, Inject } from '@angular/core';
import { Platform } from '@angular/cdk/platform';
import { NativeDateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';

/**
 * Étend NativeDateAdapter pour accepter la saisie manuelle au format jj/mm/aaaa.
 * Le NativeDateAdapter de base utilise Date.parse() qui interprète mm/dd/yyyy (US).
 */
@Injectable()
export class FrDateAdapter extends NativeDateAdapter {
  constructor(
    @Optional() @Inject(MAT_DATE_LOCALE) matDateLocale: string,
    platform: Platform,
  ) {
    super(matDateLocale, platform);
  }

  override parse(value: unknown): Date | null {
    if (typeof value === 'string' && value.trim()) {
      // Accepte jj/mm/aaaa, jj-mm-aaaa, jj.mm.aaaa
      const m = value.trim().match(/^(\d{1,2})[/\-.](\d{1,2})[/\-.](\d{4})$/);
      if (m) {
        const day = +m[1], month = +m[2] - 1, year = +m[3];
        const d = new Date(year, month, day);
        // Vérifie que la date est valide (pas de dépassement ex: 32/01/2000)
        if (d.getFullYear() === year && d.getMonth() === month && d.getDate() === day) {
          return d;
        }
        return null; // date invalide (ex: 30/02/2000)
      }
    }
    return super.parse(value);
  }
}
